import { Button } from '@/components/Button.tsx'
import { IconBrandWhatsapp } from '@tabler/icons-react'
import { useShopBrand } from '@/contexts/shopBrandContext.tsx'

export default function AboutUs() {
  const brand = useShopBrand()
  return <section>
    <div className="container mx-auto px-4 flex flex-col items-center pt-[2rem] pb-[4rem] text-center gap-4">
      <h2 className="text-3xl mb-1 font-serif">
        Über uns
      </h2>
      <p className="mb-2 max-w-[40rem]">
        {brand.name} ist ein deutsches Unternehmen aus Frankfurt am Main, das sich auf das gemeinsame Teilen von Fotos über QR-Code-Galerien spezialisiert hat. <br />
      </p>
      <p className="mb-2 max-w-[40rem]">
        In unserem Shop könnt ihr eure Lieblingsfotos direkt aus der {brand.name}-Galerie in hochwertige Drucke verwandeln.
      </p>
      <img className="max-w-[100%] md:max-w-[35rem] rounded"
           src="/team-couch.jpg" />
      <a href='https://wa.me/496987000170'
         target='_blank'>
        <Button color='primary' ><IconBrandWhatsapp /> Fragen? Schreib uns auf WhatsApp</Button>
      </a>
    </div>
  </section>
}
